// Generated by scripts/build-ui-icons.mjs.
export { CurrencyDollar as default } from "../ui/glyphs-3";
